import Vue from 'vue'
import Router from 'vue-router'

import login from '@/components/user/login'
import index from '@/components/index/index'
import liveDetail from '@/components/live/liveDetail'
import livePlayback from '@/components/live/livePlayback'

import bullStrategy from '@/components/bull_strategy/bullStrategy'
import strategyDetail from '@/components/bull_strategy/strategyDetail'
import bullClass from '@/components/bull_class/bullClass'
import classDetail from '@/components/bull_class/classDetail'
import mySubscribe from '@/components/user/mySubscribe'
import downloadApp from '@/components/download_app/downloadApp'
import Recharge from '@/components/recharge/recharge'
import rechargeAgreement from '@/components/recharge/agreement'

Vue.use(Router)

let originPush = Router.prototype.push;
let originReplace = Router.prototype.replace;
//重写push/replace
//第一个参数：告诉原来的push方法，往哪里跳转（传递哪些参数）
//第二个参数：成功的回调
//第三个参数：失败的回调
//call/apply区别
//相同点：都可以调用函数一次，都可以篡改函数的上下文(this）一次‘
//不同点：call/apply传递参数：call传递参数用逗号隔开，apply方法执行，传递数组
Router.prototype.push = function(location,resolve,reject){
  if(resolve && reject){
    originPush.call(this,location,resolve,reject);
  }else{
    originPush.call(this,location,()=>{},()=>{});
  }
}
Router.prototype.replace = function(location,resolve,reject){
  if(resolve && reject){
    originReplace.call(this,location,resolve,reject);
  }else{
    originReplace.call(this,location,()=>{},()=>{});
  }
}

export default new Router({
	routes: [
		//首页
		{
			path: '/',
			name: 'index',
			component: index,
			meta:{
				requireAuth:false,
			}
		},
		//登录页
		{
			path: '/login',
			name: 'login',
			component: login
		},
		//牛策略
		{
			path: '/bullStrategy',
			name: 'bullStrategy',
			component: bullStrategy,
			meta:{
				requireAuth:true,
			}
		},
		//牛人课
		{
			path: '/bullClass',
			name: 'bullClass',
			component: bullClass,
			meta:{
				requireAuth:true,
			}
		},
		//下载App
		{
			path: '/downloadApp',
			name: 'downloadApp',
			component: downloadApp
		},
		//充值
		{
			path: '/recharge',
			name: 'Recharge',
			component: Recharge,
			meta:{
				requireAuth:true,
			}
		},
		//充值协议
		{
			path: '/rechargeAgreement',
			name: 'rechargeAgreement',
			component: rechargeAgreement
		},
		//直播详情
		{
			path: '/liveDetail',
			name: 'liveDetail',
			component: liveDetail,
			meta:{
				requireAuth:true,
			}
		},
		//课程详情
		{
			path: '/classDetail',
			name: 'classDetail',
			component: classDetail,
			meta:{
				requireAuth:true,
			}
		},
		//策略详情
		{
			path: '/strategyDetail',
			name: 'strategyDetail',
			component: strategyDetail,
			meta:{
				requireAuth:false,
			}
		},
		//我的订阅
		{
			path: '/mySubscribe',
			name: 'mySubscribe',
			component: mySubscribe,
			meta:{
				requireAuth:true,
			}
		},
		{
			path: '/livePlayback',
			name: 'livePlayback',
			component: livePlayback,
			meta:{
				requireAuth:true,
			}
		},
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js